const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<p>
  Micro-interactions are small, singular interactions that serve one purpose:
  communicate meaningful feedback to users in a positive and welcoming
  way.`);
                this.echo(this.include(context, this.source, `@cloudfour/components/footnote-link/footnote-link.twig`, new Map([[`count`, (context.has(`count`) ? context.get(`count`) : null)]]), false, false, 4));
                this.echo(`  People like to constantly know <em>what’s</em> going to happen when an
  action is performed and tend to expect something to happen when they
  interact with it. The pop of the heart when you favorite a post, the
  elasticity of pull-to-refresh, or even snoozing your alarm are all
  examples of micro-interactions we experience every day.
  I think it’s important to take the extra time to make these experiences
  feel more human.
</p>
`);
            }

            getTemplateName() {
                return `e90a5994e8f669181239b24d6752d3d20ff5f53cb9296c29bc3ece7d1aefb6dd`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e90a5994e8f669181239b24d6752d3d20ff5f53cb9296c29bc3ece7d1aefb6dd`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'e90a5994e8f669181239b24d6752d3d20ff5f53cb9296c29bc3ece7d1aefb6dd');

let template = env.loadTemplate('e90a5994e8f669181239b24d6752d3d20ff5f53cb9296c29bc3ece7d1aefb6dd');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/footnote-link/demo/demo.twig", args: context }
     );
     return rendered;;
};